export const MuiIconButton = {
  styleOverrides: {
    root: {
      padding: '12px',
      color: 'var(--primary-main)',

      '&.buttonWithoutEffects': {
        padding: '0',
        backgroundColor: 'none',

        '.MuiTouchRipple-root': {
          display: 'none',
        },
      },
    },
  },
}
